import { datadogRum } from '@datadog/browser-rum';
import { Tags } from '../types';

/**
 * The key to use when specifying your own time in `recordMark`
 */
export const MARK_TIME_KEY = 'marked_at';

/**
 * Records a custom mark with the specified name at the current time.
 * Use `MARK_TIME_KEY` in `tags` to specify your own time.
 * @param metricName Name of the mark/metric
 * @param tags Data to include on the mark context
 */
const recordMark = (metricName: string, tags: Tags = {}) => {
  datadogRum.addAction(metricName, {
    [MARK_TIME_KEY]: window.performance.now(),
    ...tags,
  });
};

export default recordMark;
